import axios from "axios";
import { RemoteConfigProperties } from "../models/featureFlags";
export default class FeatureFlags {
    /**
     * Handlers need access to MadSDK
     * @param sdk Instance of MadSDK to use for lookups
     */
    constructor(sdk) {
        this.sdk = sdk;
        this.state = {};
        this.loading = new Promise((resolve) => {
            this.resolveLoading = resolve;
        });
    }
    isFlagEnabled(key) {
        return this.state[key] === true;
    }
    async load() {
        const res = await axios.get(`${this.sdk.urls.burnsBaseUrl}/feature-flags`);
        this.state = res.data;
        this.resolveLoading();
    }
    async loaded() {
        return this.loading;
    }
    /**
     * Enabling functionality in all environments
     */
    get useSDKFeatureFlags() {
        return true;
    }
    /**
     * Custom feature flag functions, use sparingly.
     *
     * Use Case: When a feature depends on a combination of feature flag values.
     */
    isSupplySelectorEnabled(area) {
        const isMasterSupplySelectorEnabled = this.isFlagEnabled(RemoteConfigProperties.SUPPLY_SELECTOR);
        // Map area to corresponding feature flag
        const flagMap = {
            product: RemoteConfigProperties.SUPPLY_SELECTOR_PRODUCT,
            "line item": RemoteConfigProperties.SUPPLY_SELECTOR_LINE_ITEM,
            planner: RemoteConfigProperties.SUPPLY_SELECTOR_PLANNER,
            reporting: RemoteConfigProperties.SUPPLY_SELECTOR_REPORTING
        };
        const isSpecificFlagEnabled = this.isFlagEnabled(flagMap[area]);
        // Master flag OR specific flag (master flag gates the entire feature)
        return isMasterSupplySelectorEnabled || isSpecificFlagEnabled;
    }
}
export { RemoteConfigProperties };
//# sourceMappingURL=featureFlags.js.map